import { storeSignupContext } from "@/events/signupTracking";
import { setSignupContextReporter, setUserAccess } from "@repo/shared/redux";

import type { IRootState } from "./store";
import { userIsLoggedInSelector } from "./user/userSlice";

/**
 * Web's side of the ports the shared permissions module reads through: this
 * app's nested user shape and its signup attribution. Called once at boot,
 * before anything reads a permission.
 */
export const registerPermissionsAdapters = (): void => {
  setUserAccess({
    // The existing selector, which also covers the cold start where a token
    // exists but the profile has not arrived.
    isLoggedIn: (state) => userIsLoggedInSelector(state as IRootState),
    paid: (state) => !!(state as IRootState).userReducer.user?.paid,
    lastImportedAt: (state) =>
      (state as IRootState).userReducer.user?.lastImportedAt,
    status: (state) => (state as IRootState).userReducer.status,
  });

  setSignupContextReporter(storeSignupContext);
};
